import React, { useEffect, useState } from 'react';
import { GeoJSON } from 'react-leaflet';
import { getGeometryLayerRequestPath } from '../../config/geometry-layer-urls';
import { historicAreaClassificationColors } from '../../config/conservation-colors';
import { apiGet } from '../../apiHelpers';
/** Match UHA / UHB / UHC (and variants) to Historic Area Classification colours */
export function colorForUrbanHeritage(feature) {
    const props = (feature === null || feature === void 0 ? void 0 : feature.properties) || {};
    const label = `${props.Layer || ''} ${props.Zoning_Type || ''}`.toLowerCase();
    if (label.includes('uhc') || label.includes('heritage c')) {
        return historicAreaClassificationColors.urbanHeritageC;
    }
    if (label.includes('uhb') || label.includes('heritage b')) {
        return historicAreaClassificationColors.urbanHeritageB;
    }
    // UHa / Urban Heritage a (default)
    return historicAreaClassificationColors.urbanHeritageA;
}
function urbanHeritageStyle(feature) {
    const fill = colorForUrbanHeritage(feature);
    return {
        color: '#1f4a47',
        fillColor: fill,
        fill: true,
        weight: 1,
        opacity: 1,
        // Solid fill (client: historic area classifications looked washed/transparent)
        fillOpacity: 1,
    };
}
/**
 * Parcel-level Urban Heritage A/B/C overlays.
 * Shown under Conservation → Historic Area Classifications (matches BACA historic areas maps).
 */
export function UrbanHeritageLayer() {
    const [geojson, setGeojson] = useState(null);
    useEffect(() => {
        apiGet(getGeometryLayerRequestPath('urbanHeritage'))
            .then((data) => {
            if (data && data.type === 'FeatureCollection') {
                setGeojson(data);
            }
            else {
                setGeojson(null);
            }
        })
            .catch(() => setGeojson(null));
    }, []);
    if (!geojson)
        return null;
    return (React.createElement(GeoJSON, { attribution: "Urban Heritage parcels \u2014 BACA / Colouring Bahrain", data: geojson, style: urbanHeritageStyle }));
}
